export default "__VITE_ASSET__9876095d__"